// Markets Live module — editorial sidebar widget styled like a thick-ruled stock list.
import { useEffect, useState } from "react";
import { ArrowUpRight, ArrowDownRight } from "lucide-react";

const MARKETS = [
  { k: "ASX 200",     v: "8,142.30", d: "+0.74%", up: true  },
  { k: "S&P 500",     v: "5,348.10", d: "+0.31%", up: true  },
  { k: "AUD/USD",     v: "0.6642",   d: "−0.21%", up: false },
  { k: "AUD/EUR",     v: "0.6094",   d: "+0.05%", up: true  },
  { k: "Iron Ore",    v: "$104.20",  d: "+1.12%", up: true  },
  { k: "Brent Crude", v: "$82.15",   d: "−0.48%", up: false },
  { k: "Gold",        v: "$2,431",   d: "+0.36%", up: true  },
  { k: "BHP",         v: "$44.28",   d: "+0.82%", up: true  },
  { k: "CBA",         v: "$118.40",  d: "−0.14%", up: false },
  { k: "Bitcoin",     v: "$96,820",  d: "+2.10%", up: true  },
];

const UP   = "#1A7F4F";
const DOWN = "var(--accent)";

export default function MarketsModule() {
  const [stamp, setStamp] = useState(0);
  // increment a counter every minute so the "Updated x min ago" feels live
  useEffect(() => {
    const id = setInterval(() => setStamp(s => s + 1), 60_000);
    return () => clearInterval(id);
  }, []);
  const minsAgo = stamp; // starts at 0, ticks up

  return (
    <div className="border-y" style={{borderColor:"var(--line)", borderTopWidth:3, borderBottomWidth:3}} data-testid="markets-module">
      <div className="flex items-baseline justify-between py-3">
        <h3 className="font-display text-2xl">Markets</h3>
        <span className="font-cond text-[10px] tracking-[0.18em] flex items-center gap-1.5" style={{color:"var(--fg-mute)"}}>
          <span className="live-dot"/>LIVE
        </span>
      </div>
      <ul>
        {MARKETS.map((m) => (
          <li key={m.k} className="grid grid-cols-12 items-baseline gap-2 py-2.5 border-t" style={{borderColor:"var(--line-soft)"}}>
            <span className="col-span-5 font-display text-[14px]">{m.k}</span>
            <span className="col-span-4 text-right font-mono text-[12.5px] tabular-nums">{m.v}</span>
            <span className="col-span-3 text-right font-mono text-[11.5px] tabular-nums flex items-center justify-end gap-1" style={{color: m.up ? UP : DOWN}}>
              {m.up ? <ArrowUpRight size={11}/> : <ArrowDownRight size={11}/>}
              {m.d}
            </span>
          </li>
        ))}
      </ul>
      <p className="font-mono text-[10px] py-2.5 border-t flex items-center justify-between" style={{borderColor:"var(--line-soft)", color:"var(--fg-mute)"}}>
        <span>Updated {minsAgo === 0 ? "just now" : `${minsAgo} min ago`}</span>
        <span>· source: ASX, NYSE</span>
      </p>
    </div>
  );
}
